
import { computed, defineComponent, onMounted, reactive, ref } from 'vue'
import { MrUiKitButton, MrUiKitTable, MrUiKitPagination } from 'mr-ui-kit';
import { GeneralFormatted, PaginationModel } from '@/interfaces';
import { useI18n } from 'vue-i18n';
import TrainerRoleService from '@/services/TrainerRoleService';
import axios from 'axios';
import { useStore } from 'vuex';

import TrainerRoleModal from '@/components/Backoffice/Modals/TrainerRoleModal.vue';
import DeleteEntityModal from '@/components/Backoffice/Modals/DeleteEntityModal.vue';

export default defineComponent({
    name: 'TrainerRoleList',
    emits: ['update', 'close'],
    components: {
        MrUiKitButton,
        MrUiKitTable,
        MrUiKitPagination,
        DeleteEntityModal,
        TrainerRoleModal
    },
    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    setup(props, { emit }) {
        const { t, locale } = useI18n();
        const store = useStore();
        const disciplines = ref<GeneralFormatted[]>([]);
        const showDeleteModal = ref(false);
        const selectedTrainerRole = ref<GeneralFormatted | null>(null);
        const isLoading = ref(false);
        const search = ref<string | null>(null);
        const pagination = reactive<PaginationModel>({
            current: 0,
            count: 0,
            limit: 10
        });
        const columns = reactive([
            {
                label: computed(() => t('common.fields.name')),
                field: 'name'
            },
            {
                label: '',
                field: 'action'
            }
        ]);

        onMounted(async () => {
            await onInit();
        })

        const onInit = async () => {
            pagination.current = 1;
            const total = await TrainerRoleService.count(locale.value, search.value);
            pagination.count = total.count;
            await onLoad(0);
        }

        const onLoad = async (offset: number) => {
            if (!isLoading.value) {
                isLoading.value = true;

                disciplines.value = await TrainerRoleService.get(locale.value, {
                    limit: 10,
                    offset,
                    search: search.value != null ? search.value : undefined
                });

                isLoading.value = false;
            }
        }

        const onDelete = async (sport: GeneralFormatted) => {
            selectedTrainerRole.value = sport;
            showDeleteModal.value = true;
        }

        const onSubmitDelete = async () => {
            if (selectedTrainerRole.value) {
                try {    
                    await axios.delete('/trainer-roles/' + selectedTrainerRole.value.id);
                    selectedTrainerRole.value = null;
                    await onInit();
                    store.commit('setAlert', {
                        type: 'success',
                        message: t('messages.generalSuccess.create')
                    })
                } catch (err) {
                    store.commit('setAlert', {
                        type: 'danger',
                        message: t('messages.generalError.create')
                    })
                }
            }
            showDeleteModal.value = false;
        }

        const onUpdate = (item: GeneralFormatted) => {
            selectedTrainerRole.value = item;
            emit('update');
        }

        const onCloseModal = async () => {
            selectedTrainerRole.value = null;
            await onInit();
            emit('close');
        }

        const onCloseDelete = () => {
            showDeleteModal.value = false;
            selectedTrainerRole.value = null;
        }

        const onSearch = (newS: string) => {
            if (newS != '') {
                search.value = newS;
            } else {
                search.value = null;
            }

            onInit()
        }

    const searchLabel = computed(() => {
      return t('common.findDots');
    })

        return {
            t,
            onLoad,
            onDelete,
            onUpdate,
            onSubmitDelete,
            onCloseModal,
            onCloseDelete,
            onSearch,
            searchLabel,
            showDeleteModal,
            selectedTrainerRole,
            disciplines,
            columns,
            pagination
        }
    },
})
